export const version = { buildDate: '28.10.2026 11:38' };